'use client'

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { useSession } from '@/lib/queries/session'
import { Session } from 'next-auth'
import Link from 'next/link'
import { useAvatarProvider } from '@/components/custom-ui/navigation/navigation-container/user-menu/avatar-context'

const getInitials = (user: Session['user']) => {
  return `${user.firstName?.at(0) ?? ''}${user.lastName?.at(0) ?? ''}`.toUpperCase()
}

const getFullName = (user: Session['user']) => {
  return `${user.firstName} ${user.lastName}`
}

const UserAvatar = () => {
  const { data: session } = useSession()
  const { state: avatarUrl } = useAvatarProvider()

  if (!session) {
    return null
  }

  const isB2BUser = session.user.salesChannel.includes('B2B')

  const commonContent = (
    <>
      {isB2BUser && (
        <Avatar className="h-10 w-10">
          <AvatarImage
            src={avatarUrl}
            alt={getFullName(session.user)}
            className="h-10 w-10 object-cover"
            width={40}
            height={40}
          />
          <AvatarFallback className="font-montserrat text-xl font-medium leading-[25px] tracking-[3px]">
            {getInitials(session.user)}
          </AvatarFallback>
        </Avatar>
      )}
      <p className="font-montserrat text-xl font-medium uppercase leading-[25px] tracking-[3px] text-primary">
        {getFullName(session.user)}
      </p>
    </>
  )

  if (isB2BUser) {
    return (
      <Link href="/dashboard" className="flex items-center gap-2 border-b py-2">
        {commonContent}
      </Link>
    )
  }

  return (
    <div className="flex items-center gap-2 border-b py-2">{commonContent}</div>
  )
}

export default UserAvatar
